import {Routes} from '@angular/router';

import {AdminLayoutComponent} from './layouts/admin/admin-layout.component';
import {AuthLayoutComponent} from './layouts/auth/auth-layout.component';

import { DashboardComponent } from './parent/dashboard/dashboard.component';
import { DigitalReportCardComponent } from './parent/dashboard/pages/digital-report-card/digital-report-card.component';
import { HistoricalDataSummaryComponent } from './parent/dashboard/pages/historical-data/summary.component';
//import { SemesterSummaryComponent } from './components/dataAnalytics/Digital-report-card/digital-report-card.component';
//import { MarketPlaceComponent } from './parent/dashboard/pages/market-place/market-place.component';
import { ParentHomeComponent } from './parent/dashboard/pages/parent-home/parent-home.component';
import { StudentProfileComponent } from './parent/dashboard/pages/student-details/student-profile/student-profile.component';
import { ParentComponent } from './parent/parent.component';
/////////////////////////
import { SelectdashboardHComponent } from './parent/dashboard/pages/course/Selectdashboard/selectdashboardH';
import { SelectdashboardstudentHComponent } from './parent/dashboard/pages/course/Selectdashboardstudent/selectdashboardstudentH';
import { SelectdashboardteacherHComponent } from './parent/dashboard/pages/course/Selectdashboardteacher/selectdashboardteacherH';

import { AddTSubjectQuantaComponent } from './parent/dashboard/pages/course/Teachers/addsubject.component';
import { TeachersViewQuantaComponent } from './parent/dashboard/pages/course/Teachers/teachers.component';
import { AddTeacherQuantaComponent } from './parent/dashboard/pages/course/Teachers/addTeacher.component';

import { AddsemHComponent } from './parent/dashboard/pages/course/semester/semesterH.component';
import { AddsemsubjectHComponent } from './parent/dashboard/pages/course/subject/semsubjectH.component';
import { AddsubmoduleHComponent } from './parent/dashboard/pages/course/submodule/submoduleH.component';
import { AddTeachersubjectHComponent } from './parent/dashboard/pages/course/teachersubject/teachersubjectH.component';
import { ViewcourseHComponent } from './parent/dashboard/pages/course/viewcourse/viewcourseH.component';
import { AddAcademicyearHComponent } from './parent/dashboard/pages/course/AddAcademicyear/addAcademicyearH.component';
import { AddLevelAddSchoolHComponent } from './parent/dashboard/pages/course/LevelAddSchool/AddLevelAddSchoolH';
import { AddgradetolevelHComponent } from './parent/dashboard/pages/course/AddGradeToLevel/addgradetolevelH.component';
import { AddExamsHComponent } from './parent/dashboard/pages/course/AddExams/AddExamsH';
import { AddSemesterSComponent } from './parent/dashboard/pages/course/AddSemesters/addSemesterS.component';
import { AddSubjectsSComponent } from './parent/dashboard/pages/course/AddsubjectS/addSubjectsS.component';
import { SubSubjectsSComponent } from './parent/dashboard/pages/course/SubSubjectsS/subSubjectsS.component';
import { AddBatchersHComponent } from './parent/dashboard/pages/course/batchers/batchersH.component';
import { AddTeachersubjectSComponent } from './parent/dashboard/pages/course/teachersubjectschool/teachersubjectS.component';

import { AddstudentregQComponent } from './parent/dashboard/pages/parentchild/studentreg/studentregQ.component';
import { SubParentChildQComponent } from './parent/dashboard/pages/parentchild/viewschool/parentchildQ.component';
import { StudentveiwHQComponent } from './parent/dashboard/pages/parentchild/viewhigherend/StudentveiwHQ.component';
import { SubParentChildAdvacnedQComponent } from './parent/dashboard/pages/parentchild/viewschool/parentchild_advancedQ.component';
import { DigitalReportCardQComponent2 } from './parent/dashboard/pages/course/Digital-report-card2Q/digital-report-card2Q.component';
import { RegistrationSQComponent } from './parent/dashboard/pages/parentchild/studentregSQ/registrationSQ.component';
import { PromotionsSQComponent } from './parent/dashboard/pages/parentchild/promotionsSQ/promotionsSQ.component';

import { AddTeacherComponent } from './parent/dashboard/pages/teacher-details/add-teacher/add-teacher.component';
import { DataAnalyticsComponent } from './components/dataAnalytics/dataAnalytics.component';
import { DigitalReportCardBulkUploadQuantaComponent } from './parent/dashboard/pages/course/digital-report-card-bulk-upload-q/digital-report-card-bulk-upload.component';
import { DigitalReportCardBulkUploadSComponent } from './parent/dashboard/pages/course/digital-report-card-bulk-upload-s/digital-report-card-bulk-upload.component';
import {StudentListViewComponent} from './parent/dashboard/pages/student-details/student-list-view/student-list-view.component';
import {StudentPromotionComponent} from './parent/dashboard/pages/student-details/student-promotion/student-promotion.component';
import {StudentRegistrationComponent} from './parent/dashboard/pages/student-details/student-registration/student-registration.component';
import {StudentBulkUploadComponent} from './parent/dashboard/pages/student-details/student-bulk-upload/student-bulk-upload.component';
import {ManageUserDepartmentComponent} from './parent/dashboard/pages/manage-user/manage-user-department/manage-user-department.component';
import {ManageUserComponent} from './parent/dashboard/pages/manage-user/manage-user/manage-user.component';
import {ManageAddUserComponent} from './parent/dashboard/pages/manage-user/manage-add-user/manage-add-user.component';
import {ManageUserGroupsComponent} from './parent/dashboard/pages/manage-user/manage-user-groups/manage-user-groups.component';
import {TeacherViewComponent} from './parent/dashboard/pages/teacher-details/teacher-view/teacher-view.component';
import {SubjectAssignComponent} from './parent/dashboard/pages/teacher-details/subject-assign/subject-assign.component';
import {UploadPapersComponent} from './parent/dashboard/pages/quonta-intelligence/upload-papers/upload-papers.component';
import {QuestionBankComponent} from './parent/dashboard/pages/quonta-intelligence/question-bank/question-bank.component';
import {QuestionsGeneratorComponent} from './parent/dashboard/pages/quonta-intelligence/questions-generator/questions-generator.component';
import {ManageDRCSettingsComponent} from './parent/dashboard/pages/course/ManageDRCSettings/ManageDRCSettings.component';
import {ViewPaperComponent} from './parent/dashboard/pages/quonta-intelligence/view-paper/view-paper.component';
import {ParentDRCAccessComponent} from './parent/dashboard/pages/course/ParentDRCAccess/ParentDRCAccess.component';
import {QuestionsFilterComponent} from './parent/dashboard/pages/quonta-intelligence/questions-filter/questions-filter.component';
import {GeneratedPapersComponent} from './parent/dashboard/pages/quonta-intelligence/generated-papers/generated-papers.component';
import {
  ViewGeneratedPaperComponent
} from './parent/dashboard/pages/quonta-intelligence/view-generated-paper/view-generated-paper.component';
import {FreezeDRCGradesComponent} from './parent/dashboard/pages/course/FreezeDRCGrades/FreezeDRCGrades.component';
import {SyllabusBankComponent} from './parent/dashboard/pages/quonta-intelligence/syllabus-bank/syllabus-bank.component';
import {UploadSyllabusComponent} from './parent/dashboard/pages/quonta-intelligence/upload-syllabus/upload-syllabus.component';
import {ViewSyllabusComponent} from './parent/dashboard/pages/quonta-intelligence/view-syllabus/view-syllabus.component';
import { MyNotesComponent } from './parent/dashboard/pages/quonta-intelligence/my-notes/my-notes.component';
import {PromptsComponent} from './parent/dashboard/pages/quonta-intelligence/prompts/prompts.component';
import {TranslatePapersComponent} from './parent/dashboard/pages/quonta-intelligence/translate-papers/translate-papers.component';
import {ModifyPapersComponent} from './parent/dashboard/pages/quonta-intelligence/modify-papers/modify-papers.component';


export const AppRoutes: Routes = [ {
  path: '',
  component: AuthLayoutComponent,
  children: [
    {
      path: '',
      redirectTo: 'authentication',
      pathMatch: 'full'
    },
    {
      path: 'authentication',
      loadChildren: './authentication/authentication.module#AuthenticationModule'
    }
  ]
},
{
  path: 'school',
  component: AdminLayoutComponent,
  children: [
    {
      path: '',
      redirectTo: 'dashboard',
      pathMatch: 'full'
    }, {
      path: 'dashboard',
      loadChildren: './dashboard/dashboard.module#DashboardModule'
    },
    {
      path: 'noticeboardmodule',
      loadChildren: './components/noticeboard/noticeboard.module#NoticeBoardModule'
    },
    {
      path: 'soundingboard',
      loadChildren: './components/soundingboardinbox/soundingboardinbox.module#SoundingBoardInboxModule'
    },
    {
      path: 'soundingboard/:index',
      loadChildren: './components/soundingboardinbox/soundingboardinbox.module#SoundingBoardInboxModule'
    },
    {
      path: 'calendar',
      loadChildren: './components/calendar/calendar.module#CalendarModule'
    },
    {
      path: 'settings',
      loadChildren: './components/settings/settings.module#SettingsModule'
    },
    {
      path: 'forummodule',
      loadChildren: './components/forum/forum.module#ForumModule'
    },
    {
      path: 'manageuser',
      loadChildren: './components/manageuser/manageuser.module#ManageUserModule'
    },
    {
      path: 'attendance',
      loadChildren: './components/attendance/attendance.module#AttendanceModule'
    },
    {
      path: 'assignment',
      loadChildren: './components/googleClassroom/assignment/assignment.module#AssignmentModule'
    },
    {
      path: 'parentchild',
      loadChildren: './components/parentchild/parentchild.module#ParentChildModule'
    },
    {
      path: 'googleClassroom',
      loadChildren: './components/googleClassroom/googleClassrom.module#GoogleClassroomModule'
    },
    {
      path: 'dataAnalytics',
      loadChildren: './components/dataAnalytics/dataAnalytics.module#DataAnalyticsModule'
    },
    {
      path: 'googlemeet',
      loadChildren: './components/google-meet/google-meet.module#GoogleMeetModule'
    },

    {
      path: 'userProfile',
      loadChildren: './layouts/UserProfile/userProfile.module#UserProfileModule'
    },
    {
      path: 'course',
      loadChildren: './components/course/course.module#CourseModule'
    },
    {
      path: 'batch',
      loadChildren: './components/batch/batch.module#BatchModule'
    },
    {
      path: 'teacher',
      loadChildren: './components/teachers/teachers.module#TeachersModule'
    },


  ]
}, {
  path: 'parent',
  component: DashboardComponent,
  //anActivate: [MaintenanceGuard],
  children: [
        { path: '', redirectTo: 'digital-report-card', pathMatch: 'full' },
        { path: 'student-profile', component: StudentProfileComponent },
        {path: 'student-list-view', component:StudentListViewComponent},
        {path: 'student-promotion', component:StudentPromotionComponent},
        {path: 'student-registration', component:StudentRegistrationComponent},
        {path: 'student-bulk-upload', component:StudentBulkUploadComponent},
        {path: 'manage-user-department', component:ManageUserDepartmentComponent},
        {path: 'user', component:ManageUserComponent},
        {path: 'add-manage-user', component:ManageAddUserComponent},
        {path: 'manage-user-groups', component:ManageUserGroupsComponent},
        {path: 'teacher-view', component:TeacherViewComponent},
        {path: 'add-teacher', component:AddTeacherComponent},
        {path: 'subject-assign', component:SubjectAssignComponent},
        { path: 'digital-report-card', component: DigitalReportCardComponent },
        { path: 'upload-papers', component: UploadPapersComponent },
        { path: 'modify-papers', component: ModifyPapersComponent },
        { path: 'translate-papers', component: TranslatePapersComponent },
        { path: 'upload-syllabus', component: UploadSyllabusComponent },
        { path: 'question-bank', component: QuestionBankComponent },
        { path: 'generated-papers', component: GeneratedPapersComponent },
        { path: 'syllabus-bank', component: SyllabusBankComponent },
        { path: 'questions-generator', component: QuestionsGeneratorComponent },
        { path: 'my-notes', component: MyNotesComponent },
        { path: 'questions-filter', component: QuestionsFilterComponent },
        //{ path: 'marketplace', component: MarketPlaceComponent },
        { path: 'historical-data-summary', component: HistoricalDataSummaryComponent },
		    { path: 'student-analytics', component: HistoricalDataSummaryComponent },
		    { path: 'individual-performance', component: HistoricalDataSummaryComponent },
        { path: 'grade-analytics', component: HistoricalDataSummaryComponent },
		    { path: 'teacher-analytics', component: HistoricalDataSummaryComponent },
		    { path: 'academic-trends', component: HistoricalDataSummaryComponent },
		    { path: 'extracurricular-analysis', component: HistoricalDataSummaryComponent },
        { path: 'course-analytics', component: HistoricalDataSummaryComponent },
        { path: 'secular-trends', component: HistoricalDataSummaryComponent },
        { path: 'not-enabled', component: ParentHomeComponent },

        { path: 'dashboard', component: SelectdashboardHComponent },
        { path: 'Student', component: SelectdashboardstudentHComponent },
        { path: 'Teacher', component: SelectdashboardteacherHComponent },

        { path: 'add-semester', component: AddSemesterSComponent },
        { path: 'add-subject', component: AddsemsubjectHComponent },
        { path: 'subject', component:  AddSubjectsSComponent },
        { path: 'sub-subject', component:  SubSubjectsSComponent },
        { path: 'manage-drc-settings', component:  ManageDRCSettingsComponent },
        { path: 'freeze-drc-grades', component:  FreezeDRCGradesComponent },
        { path: 'parent-drc-access', component:  ParentDRCAccessComponent },
        { path: 'view-paper', component:  ViewPaperComponent },
        { path: 'prompts', component:  PromptsComponent },
        { path: 'view-syllabus', component:  ViewSyllabusComponent },
        { path: 'view-generated-paper', component:  ViewGeneratedPaperComponent },


        { path: 'View/child/:child_id', component: SubParentChildAdvacnedQComponent },



        { path: 'add-submodule', component: AddsubmoduleHComponent },
        { path: 'add-teacher-sub', component: AddTeachersubjectHComponent },
        { path: 'view-course', component: ViewcourseHComponent },
        { path: 'add-academic-year', component: AddAcademicyearHComponent },
        { path: 'add-level', component: AddLevelAddSchoolHComponent },
        { path: 'add-grade-to-level', component: AddgradetolevelHComponent },
        { path: 'add-exam', component: AddExamsHComponent },
        { path: 'semester', component: AddsemHComponent},
        { path: 'add-batch', component: AddBatchersHComponent},

        { path: 'registration', component: AddstudentregQComponent},
        { path: 'school-Q-registration', component: RegistrationSQComponent},
        { path: 'school-Q-promotion', component: PromotionsSQComponent},
        { path: 'subject-teacher', component: AddTeachersubjectSComponent},


        { path: 'view', component: SubParentChildQComponent},
        { path: 'view-Higher-end', component: StudentveiwHQComponent},
        { path: 'digital-report-card-HigherEd', component: DigitalReportCardQComponent2},

        { path: 'Add-subject-T', component: AddTSubjectQuantaComponent},
        { path: 'view-T', component: TeachersViewQuantaComponent},
        { path: 'Add-teacher-T', component: AddTeacherQuantaComponent},
        { path: 'Bulk-upload', component: DigitalReportCardBulkUploadQuantaComponent},
        { path: 'Bulk-upload-s', component: DigitalReportCardBulkUploadSComponent},





        /*{
          path: "sem",
          component: courseHComponent,
          loadChildren: () =>
            import(`./parent/dashboard/pages/course/courseH.module`).then(m => m.CourseModule)
          }*/

  ]
}, {
  path: ':section',
  redirectTo: 'school/:section'
}, {
  path: ':section/:sub_route',
  redirectTo: 'school/:section/:sub_route'
}, {
  path: ':section/:sub_route/:sub_route2',
  redirectTo: 'school/:section/:sub_route/:sub_route2'
}, {
  path: '**',
  redirectTo: 'error/404'
},
];



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/app.routing.ts